// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__6joli","tabsBox":"styles_tabsBox__1pRmn","createButton":"styles_createButton__1OgEU"};